import BaseService from "./BaseService";

class NotificationService {
  static async list() {
    return await BaseService.callAPI("/notifications", "GET");
  }

  static async updateNotificationStatus({ id, status }) {
    return await BaseService.callAPI(
      `/notifications/${id}/status/${status}`,
      "POST",
      null
    );
  }
}

export default NotificationService;
